__turbopack_context__.v({
  "content": "ResearchSection-module__IHcjTW__content",
  "description": "ResearchSection-module__IHcjTW__description",
  "description-content": "ResearchSection-module__IHcjTW__description-content",
  "desktop-only": "ResearchSection-module__IHcjTW__desktop-only",
  "mobile-only": "ResearchSection-module__IHcjTW__mobile-only",
  "research-description": "ResearchSection-module__IHcjTW__research-description",
  "research-descriptions": "ResearchSection-module__IHcjTW__research-descriptions",
  "root": "ResearchSection-module__IHcjTW__root",
});
